
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as faq0GEssjTAdVHUwv8FXdR2P4k43nGr4F46PGCZaunmAEIMeta } from "/usr/src/app/apps/site-sk/app/pages/faq.vue?macro=true";
import { default as blogaJxq8ZeSqRq9ROaleOatDIqjHRCX5IlSdnazcwrAq9YMeta } from "/usr/src/app/apps/site-sk/app/pages/blog.vue?macro=true";
import { default as cartQ0DSoJXor5lHSJDlGslfcgD4K5FMCMDHqKi_OcjUmcoMeta } from "/usr/src/app/apps/site-sk/app/pages/cart.vue?macro=true";
import { default as jobs51fF7U11rGKIVyL9FRBuhT4PUb2MO2vh2dRfoSFhhW8Meta } from "/usr/src/app/apps/site-sk/app/pages/jobs.vue?macro=true";
import { default as index6HmpLvSetNjGYzTiuXO4_1gk0oEau4r4WDEtwAe6seIMeta } from "/usr/src/app/apps/site-sk/app/pages/index.vue?macro=true";
import { default as pressT_sT6uCL5ZeihYqoD_2n63OPrYMMMEY07W037Xxjv58Meta } from "/usr/src/app/apps/site-sk/app/pages/press.vue?macro=true";
import { default as terms_RVR2V8JbGBWKNdZWwR8BDCT_qN4OyptgJlN5DM1ErAMeta } from "/usr/src/app/apps/site-sk/app/pages/terms.vue?macro=true";
import { default as _debugMhLZlSWNecLZdXto8DpsACbxhN2tY2RFoBiLdTRGl7EMeta } from "/usr/src/app/apps/site-sk/app/pages/_debug.vue?macro=true";
import { default as retailSrAvJIN96jNy8k8Xh2IarYeqByrTbkUiGQHEr8raABgMeta } from "/usr/src/app/apps/site-sk/app/pages/retail.vue?macro=true";
import { default as searchzYiMsp3jzNjHvfGzhMBhPmQ1OZFHpRSrKkgHHrNoSEoMeta } from "/usr/src/app/apps/site-sk/app/pages/search.vue?macro=true";
import { default as stores3iFbCyKkz9ntTKEHkFYdkXDyTfBxUmtDqkg7y6Y_Z_AMeta } from "/usr/src/app/apps/site-sk/app/pages/stores.vue?macro=true";
import { default as index78COuDAG2VERUcR_NAWTssL4JgUeVTRLG2wnSl5T_34Meta } from "/usr/src/app/apps/site-sk/app/pages/account/index.vue?macro=true";
import { default as bodiesMS1QXaZBb_lMSxAtPy6SIh_ysi_VcuY1915syoodES4Meta } from "/usr/src/app/apps/site-sk/app/pages/account/bodies.vue?macro=true";
import { default as claimsy2GVJBTlyyi7WWIWhOekhh7S6AsmCo9lzjtjeD6E_IkMeta } from "/usr/src/app/apps/site-sk/app/pages/account/claims.vue?macro=true";
import { default as ordersWK2JCg2MBk5ayEi5tUuGQ6QTC6SVKXnbuD0W_W2uK4IMeta } from "/usr/src/app/apps/site-sk/app/pages/account/orders.vue?macro=true";
import { default as autopayk6IdUVqv6sHvQGQae9EykasZXfevzUq0IrXnS3Kq_8oMeta } from "/usr/src/app/apps/site-sk/app/pages/account/autopay.vue?macro=true";
import { default as balanceTt0ma9WmPlzXI_j13cEbbDhZwaoxuQ_vVb_73ialtjsMeta } from "/usr/src/app/apps/site-sk/app/pages/account/balance.vue?macro=true";
import { default as contactrJVw_aEsAXVGRQy9cY2D5zEomDod_cb7Igd7uMFCsZgMeta } from "/usr/src/app/apps/site-sk/app/pages/account/contact.vue?macro=true";
import { default as profilew1PWbC_ByELiC_wnwbesp_gDMukma6HLxu6U5ThDkaIMeta } from "/usr/src/app/apps/site-sk/app/pages/account/profile.vue?macro=true";
import { default as returnst6uKCZnD83_z4d2KhcM94p0cgxPSRxsau34YKfLl8B8Meta } from "/usr/src/app/apps/site-sk/app/pages/account/returns.vue?macro=true";
import { default as invoicesTXDJM1XdJwtkrL_Rilvm5uuvrCTk_ZxdUEklbBZ9ZigMeta } from "/usr/src/app/apps/site-sk/app/pages/account/invoices.vue?macro=true";
import { default as sku_45listCOWlSVsf8Zo1YIALYorsAUNO63UrYHjOzR4VHU0NDm4Meta } from "/usr/src/app/apps/site-sk/app/pages/account/sku-list.vue?macro=true";
import { default as vouchersI397ZzwHlNDwuyRy_eT06Q9LAqWSk6D2iKW1JtCYL7gMeta } from "/usr/src/app/apps/site-sk/app/pages/account/vouchers.vue?macro=true";
import { default as addressestxKBbABvhlJqAZiZFObwaUWrm_D7DGF6kUgZWYjD1s0Meta } from "/usr/src/app/apps/site-sk/app/pages/account/addresses.vue?macro=true";
import { default as agreementsNaJ7TjVwuD4cQ1EpXr9mI3ENLTsf2QZOmF5Vo_xTuE8Meta } from "/usr/src/app/apps/site-sk/app/pages/account/agreements.vue?macro=true";
import { default as bulk_45ordervUSZQ5iWXeF_TnbOWYHM14QfIfoBV_3uz7b7JQuTg5cMeta } from "/usr/src/app/apps/site-sk/app/pages/account/bulk-order.vue?macro=true";
import { default as map_45policyFZRIdkm4vIHp4Y06jEr4JoyIRP_RECVBBh1bRZEcuAYMeta } from "/usr/src/app/apps/site-sk/app/pages/account/map-policy.vue?macro=true";
import { default as product_45listMF9gFNCIkalLa4_KhHEQCeQ58bJMygeHzCpq1nY_fP8Meta } from "/usr/src/app/apps/site-sk/app/pages/account/product-list.vue?macro=true";
import { default as sku_45launcheswz5oGCn8vQNwEZMdXphCmhHOkhQO8OJFHdrpyXbfRBEMeta } from "/usr/src/app/apps/site-sk/app/pages/account/sku-launches.vue?macro=true";
import { default as pricing_45terms0Yk7nmuqKJXRMjFc6yt6Anld2rkGL9Qls_vWphDTu34Meta } from "/usr/src/app/apps/site-sk/app/pages/account/pricing-terms.vue?macro=true";
import { default as registrationssAZaUF9U0C9CoyEB4YP6jVMtt4wUTciX9R8KzYtuOHoMeta } from "/usr/src/app/apps/site-sk/app/pages/account/registrations.vue?macro=true";
import { default as subscriptionsa52dOoUsfA5hLwsZYwvltOWCbdnArzDcLKDu4NFOvRgMeta } from "/usr/src/app/apps/site-sk/app/pages/account/subscriptions.vue?macro=true";
import { default as customizationsqczmEwi7jklxAfLquE1Mga4pH_lxYFnbwJLEULjBQ_sMeta } from "/usr/src/app/apps/site-sk/app/pages/account/customizations.vue?macro=true";
import { default as manage_45membersLKsM7ygJRTxzptpVGhpx99JvCSjM6ZfhkaLQNa75d2gMeta } from "/usr/src/app/apps/site-sk/app/pages/account/manage-members.vue?macro=true";
import { default as payment_45methodsc61KLgdGVycmz47NRKaAYhkMtbklqYYTNOdkNpEzWwYMeta } from "/usr/src/app/apps/site-sk/app/pages/account/payment-methods.vue?macro=true";
import { default as marketing_45assetswL7QE6ExpMORJDUYOgVENwKMroHl_9cQ3rvU0WBLKnUMeta } from "/usr/src/app/apps/site-sk/app/pages/account/marketing-assets.vue?macro=true";
import { default as product_45launchesEsRbsjnA9IbpZFDSE43uVPxCCYhngFC5WkV3b_uWogAMeta } from "/usr/src/app/apps/site-sk/app/pages/account/product-launches.vue?macro=true";
import { default as third_45party_45marketplace_45policyXWaAWwHc6WFwUan9pY3Y9TXPkeNKlAZLQVOfzOC_YmEMeta } from "/usr/src/app/apps/site-sk/app/pages/account/third-party-marketplace-policy.vue?macro=true";
import { default as accountgRQdHOCEV5B8XRgQHCYl7Sim5BIONgzaT3m4QfY6yfgMeta } from "/usr/src/app/apps/site-sk/app/pages/account.vue?macro=true";
import { default as contactZeaiFjAC4tn5hiMtV_FjsxSUsJjNMqu1Au0sZW7kY4oMeta } from "/usr/src/app/apps/site-sk/app/pages/contact.vue?macro=true";
import { default as contentXNsdWZ3RZgemeQpiXMa5B7dmt4LX_vTKTzMtYakh6SsMeta } from "/usr/src/app/apps/site-sk/app/pages/content.vue?macro=true";
import { default as privacyLC4IFVkwBtzwc1t2IrS2pG4EWdelU7SKGnPy7pmLhxwMeta } from "/usr/src/app/apps/site-sk/app/pages/privacy.vue?macro=true";
import { default as returnsgYYE8fQm7ulAmdiQwjfhFAbx9_57tB9S4WVYSPQ4AYIMeta } from "/usr/src/app/apps/site-sk/app/pages/returns.vue?macro=true";
import { default as reviewsI_3ilQLzDgifNv3_wMqQ_OLZmQMrnLtTCyNMCyoc3ToMeta } from "/usr/src/app/apps/site-sk/app/pages/reviews.vue?macro=true";
import { default as sign_45inTEore6tKIl5rq41OB5PX26Ys0whExcVFbdpFPS_WX0EMeta } from "/usr/src/app/apps/site-sk/app/pages/sign-in.vue?macro=true";
import { default as indexsmm7hn3DiASib16_YmhrZ6Joeok4a_9eDSsNCRAUqqQMeta } from "/usr/src/app/apps/site-sk/app/pages/checkout/index.vue?macro=true";
import { default as checkout6uXQW6IriqthBqk_Te5pVx_fh8O7ec0liLCMVPUHOeAMeta } from "/usr/src/app/apps/site-sk/app/pages/checkout.vue?macro=true";
import { default as sign_45outBNdOCdn7AEXHWMRTVyDoyclTOauvm1pSIK6UulKslU8Meta } from "/usr/src/app/apps/site-sk/app/pages/sign-out.vue?macro=true";
import { default as _settingsw8teLedD50794EPzrPzQtS0f7m71IANgxZ_MOEADe0cMeta } from "/usr/src/app/apps/site-sk/app/pages/_settings.vue?macro=true";
import { default as va_45productsjvVR27Pqr_en_UT_V7z4dY0vdQofOvSQWfUDh3dh2K0Meta } from "/usr/src/app/apps/site-sk/app/pages/va-products.vue?macro=true";
import { default as order_45status1Bh5khtYxvDlVKoM3sX7vntGAFK9ELytGATiK3l4t8gMeta } from "/usr/src/app/apps/site-sk/app/pages/order-status.vue?macro=true";
import { default as set_45passwordKJWB44ohpVZt8Eb4I09KWwmxULgZ64lyIqNWWdMPJR4Meta } from "/usr/src/app/apps/site-sk/app/pages/set-password.vue?macro=true";
import { default as subscriptionsUxd51iM0YtjxKWObPr0yWB1dHiAPHtc6XIik22nLxY0Meta } from "/usr/src/app/apps/site-sk/app/pages/subscriptions.vue?macro=true";
import { default as index7i_n7S18jTLnrer3Pe7YVoPzlJzC0ykd3XZVN9sMfXMMeta } from "/usr/src/app/apps/site-sk/app/pages/support/index.vue?macro=true";
import { default as indexIvazdNc4_zVPkjJSKqe5Za5UsMCpHyHJ2WwJYM_IkdQMeta } from "/usr/src/app/apps/site-sk/app/pages/create-account/index.vue?macro=true";
import { default as step_452sKdHBzJagInsEcqJkbcaIG2eeVRQFCkJfxeMIVDqW5kMeta } from "/usr/src/app/apps/site-sk/app/pages/create-account/step-2.vue?macro=true";
import { default as create_45accountQGTqikahQVHWgwfs9zyC8ttqiLsvmSV11IUF_aQgVFcMeta } from "/usr/src/app/apps/site-sk/app/pages/create-account.vue?macro=true";
import { default as refer_45a_45friend1G7wWt8PBiehrVP7PQe8JDBXzTONluKyjI3qYVvS0XQMeta } from "/usr/src/app/apps/site-sk/app/pages/refer-a-friend.vue?macro=true";
import { default as reset_45password1vl5_7f8xBmJezbK8lVW6QLKakd5ibZULZcKspSgl38Meta } from "/usr/src/app/apps/site-sk/app/pages/reset-password.vue?macro=true";
import { default as _91txnUid_9371Q88gWef7OC7Zc9OocEBIXwglfcdm3qydt4hMrmI00Meta } from "/usr/src/app/apps/site-sk/app/pages/sales/[txnUid].vue?macro=true";
import { default as forgot_45password69dK7S6U_q7gF9Ij4Ztnl2FgfYu9LHo_dr1DaIMPxdQMeta } from "/usr/src/app/apps/site-sk/app/pages/forgot-password.vue?macro=true";
import { default as listU3zwsTqQAXAW7MzOiP483a2o2F84asDIVkeclCWHAsIMeta } from "/usr/src/app/apps/site-sk/app/pages/product-catalog/list.vue?macro=true";
import { default as product_45catalogYc5R3h2Wgz67IiX5rise0d4Hpdjf1es1_nvOHyC5wDAMeta } from "/usr/src/app/apps/site-sk/app/pages/product-catalog.vue?macro=true";
import { default as garment_45feedbackrSqunIcmK8chaMaURAU27qy6ryc3UBFGFZiBAbdiNa4Meta } from "/usr/src/app/apps/site-sk/app/pages/garment-feedback.vue?macro=true";
import { default as teamsc8XTOA_e_LbuqlLYWVQtA33a88_nakyK4QPrKJ8sZpwMeta } from "/usr/src/app/apps/site-sk/app/pages/onboarding/teams.vue?macro=true";
import { default as warrantyNIwsNpBIcBbXdqb0ukQvHH7tLZe_gOOVKl5lK1h9C1YMeta } from "/usr/src/app/apps/site-sk/app/pages/support/warranty.vue?macro=true";
import { default as confirmation4cpyrvksOy0N7gPDVagq2vzMOcJFpFPqjOrjeqMPxzQMeta } from "/usr/src/app/apps/site-sk/app/pages/order/confirmation.vue?macro=true";
import { default as retailers0ro5QrV14Yn_MrL0GvN6OzjdWkZA7Q2ams_AkwrIcMcMeta } from "/usr/src/app/apps/site-sk/app/pages/onboarding/retailers.vue?macro=true";
import { default as _91uid_93HVyqa9fr2MAXBIoV9jE3UHVJqaGTfWhRiBpobk_Cro8Meta } from "/usr/src/app/apps/site-sk/app/pages/accept-invitation/[uid].vue?macro=true";
import { default as organizationsEfmSpOUEFEkEKj2NLxZ_sgTyYTvnEds5RIFm8WCZM1QMeta } from "/usr/src/app/apps/site-sk/app/pages/onboarding/organizations.vue?macro=true";
import { default as component_45stubtRLCMQ8C9tb_1wVAXA6zyyB2mYAIZfgpGxFzL5jBrdQMeta } from "/usr/src/app/node_modules/.pnpm/nuxt@4.3.1_@parcel+watcher@2.5.6_@types+node@25.2.3_@vue+compiler-sfc@3.5.28_cac@6.7.14_efe9f3fe513440bfc081083fadd22ad0/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubtRLCMQ8C9tb_1wVAXA6zyyB2mYAIZfgpGxFzL5jBrdQ } from "/usr/src/app/node_modules/.pnpm/nuxt@4.3.1_@parcel+watcher@2.5.6_@types+node@25.2.3_@vue+compiler-sfc@3.5.28_cac@6.7.14_efe9f3fe513440bfc081083fadd22ad0/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "faq",
    path: "/faq",
    meta: faq0GEssjTAdVHUwv8FXdR2P4k43nGr4F46PGCZaunmAEIMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/faq.vue")
  },
  {
    name: "blog",
    path: "/blog",
    meta: blogaJxq8ZeSqRq9ROaleOatDIqjHRCX5IlSdnazcwrAq9YMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/blog.vue")
  },
  {
    name: "cart",
    path: "/cart",
    meta: cartQ0DSoJXor5lHSJDlGslfcgD4K5FMCMDHqKi_OcjUmcoMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/cart.vue")
  },
  {
    name: "jobs",
    path: "/jobs",
    meta: jobs51fF7U11rGKIVyL9FRBuhT4PUb2MO2vh2dRfoSFhhW8Meta || {},
    alias: ["/company/jobs"],
    component: () => import("/usr/src/app/apps/site-sk/app/pages/jobs.vue")
  },
  {
    name: "index",
    path: "/",
    meta: index6HmpLvSetNjGYzTiuXO4_1gk0oEau4r4WDEtwAe6seIMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/index.vue")
  },
  {
    name: "press",
    path: "/press",
    meta: pressT_sT6uCL5ZeihYqoD_2n63OPrYMMMEY07W037Xxjv58Meta || {},
    alias: ["/company/press"],
    component: () => import("/usr/src/app/apps/site-sk/app/pages/press.vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: terms_RVR2V8JbGBWKNdZWwR8BDCT_qN4OyptgJlN5DM1ErAMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/terms.vue")
  },
  {
    name: "_debug",
    path: "/_debug",
    component: () => import("/usr/src/app/apps/site-sk/app/pages/_debug.vue")
  },
  {
    name: "retail",
    path: "/retail",
    meta: retailSrAvJIN96jNy8k8Xh2IarYeqByrTbkUiGQHEr8raABgMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/retail.vue")
  },
  {
    name: "search",
    path: "/search",
    meta: searchzYiMsp3jzNjHvfGzhMBhPmQ1OZFHpRSrKkgHHrNoSEoMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/search.vue")
  },
  {
    name: "stores",
    path: "/stores",
    meta: stores3iFbCyKkz9ntTKEHkFYdkXDyTfBxUmtDqkg7y6Y_Z_AMeta || {},
    alias: ["/retailers/stores"],
    component: () => import("/usr/src/app/apps/site-sk/app/pages/stores.vue")
  },
  {
    name: accountgRQdHOCEV5B8XRgQHCYl7Sim5BIONgzaT3m4QfY6yfgMeta?.name,
    path: "/account",
    meta: { ...(accountgRQdHOCEV5B8XRgQHCYl7Sim5BIONgzaT3m4QfY6yfgMeta || {}), ...{"middleware":["auth","account-guard"]} },
    component: () => import("/usr/src/app/apps/site-sk/app/pages/account.vue"),
    children: [
  {
    name: "account",
    path: "",
    component: () => import("/usr/src/app/apps/site-sk/app/pages/account/index.vue")
  },
  {
    name: "account-bodies",
    path: "bodies",
    meta: bodiesMS1QXaZBb_lMSxAtPy6SIh_ysi_VcuY1915syoodES4Meta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/account/bodies.vue")
  },
  {
    name: "account-claims",
    path: "claims",
    meta: claimsy2GVJBTlyyi7WWIWhOekhh7S6AsmCo9lzjtjeD6E_IkMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/account/claims.vue")
  },
  {
    name: "account-orders",
    path: "orders",
    meta: ordersWK2JCg2MBk5ayEi5tUuGQ6QTC6SVKXnbuD0W_W2uK4IMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/account/orders.vue")
  },
  {
    name: "account-autopay",
    path: "autopay",
    meta: autopayk6IdUVqv6sHvQGQae9EykasZXfevzUq0IrXnS3Kq_8oMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/account/autopay.vue")
  },
  {
    name: "account-balance",
    path: "balance",
    meta: balanceTt0ma9WmPlzXI_j13cEbbDhZwaoxuQ_vVb_73ialtjsMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/account/balance.vue")
  },
  {
    name: "account-contact",
    path: "contact",
    meta: contactrJVw_aEsAXVGRQy9cY2D5zEomDod_cb7Igd7uMFCsZgMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/account/contact.vue")
  },
  {
    name: "account-profile",
    path: "profile",
    meta: profilew1PWbC_ByELiC_wnwbesp_gDMukma6HLxu6U5ThDkaIMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/account/profile.vue")
  },
  {
    name: "account-returns",
    path: "returns",
    meta: returnst6uKCZnD83_z4d2KhcM94p0cgxPSRxsau34YKfLl8B8Meta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/account/returns.vue")
  },
  {
    name: "account-invoices",
    path: "invoices",
    meta: invoicesTXDJM1XdJwtkrL_Rilvm5uuvrCTk_ZxdUEklbBZ9ZigMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/account/invoices.vue")
  },
  {
    name: "account-sku-list",
    path: "sku-list",
    meta: sku_45listCOWlSVsf8Zo1YIALYorsAUNO63UrYHjOzR4VHU0NDm4Meta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/account/sku-list.vue")
  },
  {
    name: "account-vouchers",
    path: "vouchers",
    meta: vouchersI397ZzwHlNDwuyRy_eT06Q9LAqWSk6D2iKW1JtCYL7gMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/account/vouchers.vue")
  },
  {
    name: "account-addresses",
    path: "addresses",
    meta: addressestxKBbABvhlJqAZiZFObwaUWrm_D7DGF6kUgZWYjD1s0Meta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/account/addresses.vue")
  },
  {
    name: "account-agreements",
    path: "/account/agreements/:agreementUid?",
    meta: agreementsNaJ7TjVwuD4cQ1EpXr9mI3ENLTsf2QZOmF5Vo_xTuE8Meta || {},
    alias: ["/account/agreements/:agreementUid?"],
    component: () => import("/usr/src/app/apps/site-sk/app/pages/account/agreements.vue")
  },
  {
    name: "account-bulk-order",
    path: "bulk-order",
    meta: bulk_45ordervUSZQ5iWXeF_TnbOWYHM14QfIfoBV_3uz7b7JQuTg5cMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/account/bulk-order.vue")
  },
  {
    name: "account-map-policy",
    path: "map-policy",
    meta: map_45policyFZRIdkm4vIHp4Y06jEr4JoyIRP_RECVBBh1bRZEcuAYMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/account/map-policy.vue")
  },
  {
    name: "account-product-list",
    path: "product-list",
    meta: product_45listMF9gFNCIkalLa4_KhHEQCeQ58bJMygeHzCpq1nY_fP8Meta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/account/product-list.vue")
  },
  {
    name: "account-sku-launches",
    path: "sku-launches",
    meta: sku_45launcheswz5oGCn8vQNwEZMdXphCmhHOkhQO8OJFHdrpyXbfRBEMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/account/sku-launches.vue")
  },
  {
    name: "account-pricing-terms",
    path: "pricing-terms",
    meta: pricing_45terms0Yk7nmuqKJXRMjFc6yt6Anld2rkGL9Qls_vWphDTu34Meta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/account/pricing-terms.vue")
  },
  {
    name: "account-registrations",
    path: "registrations",
    meta: registrationssAZaUF9U0C9CoyEB4YP6jVMtt4wUTciX9R8KzYtuOHoMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/account/registrations.vue")
  },
  {
    name: "account-subscriptions",
    path: "subscriptions",
    meta: subscriptionsa52dOoUsfA5hLwsZYwvltOWCbdnArzDcLKDu4NFOvRgMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/account/subscriptions.vue")
  },
  {
    name: "account-customizations",
    path: "customizations",
    meta: customizationsqczmEwi7jklxAfLquE1Mga4pH_lxYFnbwJLEULjBQ_sMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/account/customizations.vue")
  },
  {
    name: "account-manage-members",
    path: "manage-members",
    meta: manage_45membersLKsM7ygJRTxzptpVGhpx99JvCSjM6ZfhkaLQNa75d2gMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/account/manage-members.vue")
  },
  {
    name: "account-payment-methods",
    path: "payment-methods",
    meta: payment_45methodsc61KLgdGVycmz47NRKaAYhkMtbklqYYTNOdkNpEzWwYMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/account/payment-methods.vue")
  },
  {
    name: "account-marketing-assets",
    path: "marketing-assets",
    meta: marketing_45assetswL7QE6ExpMORJDUYOgVENwKMroHl_9cQ3rvU0WBLKnUMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/account/marketing-assets.vue")
  },
  {
    name: "account-product-launches",
    path: "product-launches",
    meta: product_45launchesEsRbsjnA9IbpZFDSE43uVPxCCYhngFC5WkV3b_uWogAMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/account/product-launches.vue")
  },
  {
    name: "account-third-party-marketplace-policy",
    path: "third-party-marketplace-policy",
    meta: third_45party_45marketplace_45policyXWaAWwHc6WFwUan9pY3Y9TXPkeNKlAZLQVOfzOC_YmEMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/account/third-party-marketplace-policy.vue")
  }
]
  },
  {
    name: "contact",
    path: "/contact",
    meta: contactZeaiFjAC4tn5hiMtV_FjsxSUsJjNMqu1Au0sZW7kY4oMeta || {},
    alias: ["/support/contact"],
    component: () => import("/usr/src/app/apps/site-sk/app/pages/contact.vue")
  },
  {
    name: "content",
    path: "/content/:catchAll(.*)",
    meta: contentXNsdWZ3RZgemeQpiXMa5B7dmt4LX_vTKTzMtYakh6SsMeta || {},
    alias: ["/:catchAll(.*)"],
    component: () => import("/usr/src/app/apps/site-sk/app/pages/content.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    meta: privacyLC4IFVkwBtzwc1t2IrS2pG4EWdelU7SKGnPy7pmLhxwMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/privacy.vue")
  },
  {
    name: "returns",
    path: "/returns",
    meta: returnsgYYE8fQm7ulAmdiQwjfhFAbx9_57tB9S4WVYSPQ4AYIMeta || {},
    alias: ["/support/returns/"],
    component: () => import("/usr/src/app/apps/site-sk/app/pages/returns.vue")
  },
  {
    name: "reviews",
    path: "/reviews",
    meta: reviewsI_3ilQLzDgifNv3_wMqQ_OLZmQMrnLtTCyNMCyoc3ToMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/reviews.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: sign_45inTEore6tKIl5rq41OB5PX26Ys0whExcVFbdpFPS_WX0EMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/sign-in.vue")
  },
  {
    name: checkout6uXQW6IriqthBqk_Te5pVx_fh8O7ec0liLCMVPUHOeAMeta?.name,
    path: "/checkout",
    meta: checkout6uXQW6IriqthBqk_Te5pVx_fh8O7ec0liLCMVPUHOeAMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/checkout.vue"),
    children: [
  {
    name: "checkout",
    path: "",
    component: () => import("/usr/src/app/apps/site-sk/app/pages/checkout/index.vue")
  }
]
  },
  {
    name: "sign-out",
    path: "/sign-out",
    meta: sign_45outBNdOCdn7AEXHWMRTVyDoyclTOauvm1pSIK6UulKslU8Meta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/sign-out.vue")
  },
  {
    name: "_settings",
    path: "/_settings",
    component: () => import("/usr/src/app/apps/site-sk/app/pages/_settings.vue")
  },
  {
    name: "va-products",
    path: "/va-products",
    component: () => import("/usr/src/app/apps/site-sk/app/pages/va-products.vue")
  },
  {
    name: "order-status",
    path: "/order-status",
    meta: order_45status1Bh5khtYxvDlVKoM3sX7vntGAFK9ELytGATiK3l4t8gMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/order-status.vue")
  },
  {
    name: "set-password",
    path: "/set-password",
    meta: set_45passwordKJWB44ohpVZt8Eb4I09KWwmxULgZ64lyIqNWWdMPJR4Meta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/set-password.vue")
  },
  {
    name: "subscriptions",
    path: "/subscriptions",
    meta: subscriptionsUxd51iM0YtjxKWObPr0yWB1dHiAPHtc6XIik22nLxY0Meta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/subscriptions.vue")
  },
  {
    name: "support",
    path: "/support",
    meta: index7i_n7S18jTLnrer3Pe7YVoPzlJzC0ykd3XZVN9sMfXMMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/support/index.vue")
  },
  {
    name: create_45accountQGTqikahQVHWgwfs9zyC8ttqiLsvmSV11IUF_aQgVFcMeta?.name,
    path: "/create-account",
    meta: create_45accountQGTqikahQVHWgwfs9zyC8ttqiLsvmSV11IUF_aQgVFcMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/create-account.vue"),
    children: [
  {
    name: "create-account",
    path: "",
    meta: indexIvazdNc4_zVPkjJSKqe5Za5UsMCpHyHJ2WwJYM_IkdQMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/create-account/index.vue")
  },
  {
    name: "create-account-step-2",
    path: "step-2",
    meta: step_452sKdHBzJagInsEcqJkbcaIG2eeVRQFCkJfxeMIVDqW5kMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/create-account/step-2.vue")
  }
]
  },
  {
    name: "refer-a-friend",
    path: "/refer-a-friend",
    meta: refer_45a_45friend1G7wWt8PBiehrVP7PQe8JDBXzTONluKyjI3qYVvS0XQMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/refer-a-friend.vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    meta: reset_45password1vl5_7f8xBmJezbK8lVW6QLKakd5ibZULZcKspSgl38Meta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/reset-password.vue")
  },
  {
    name: "sales-txnUid",
    path: "/sales/:txnUid",
    meta: _91txnUid_9371Q88gWef7OC7Zc9OocEBIXwglfcdm3qydt4hMrmI00Meta || {},
    alias: ["/order/:txnUid","/invoice/:txnUid"],
    component: () => import("/usr/src/app/apps/site-sk/app/pages/sales/[txnUid].vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    meta: forgot_45password69dK7S6U_q7gF9Ij4Ztnl2FgfYu9LHo_dr1DaIMPxdQMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/forgot-password.vue")
  },
  {
    name: "product-catalog",
    path: "/product-catalog",
    meta: product_45catalogYc5R3h2Wgz67IiX5rise0d4Hpdjf1es1_nvOHyC5wDAMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/product-catalog.vue"),
    children: [
  {
    name: "product-catalog-list",
    path: "/product-catalog/:deeplink(.*)",
    meta: listU3zwsTqQAXAW7MzOiP483a2o2F84asDIVkeclCWHAsIMeta || {},
    alias: ["/product-catalog/:deeplink(.*)"],
    component: () => import("/usr/src/app/apps/site-sk/app/pages/product-catalog/list.vue")
  }
]
  },
  {
    name: "garment-feedback",
    path: "/garment-feedback",
    meta: garment_45feedbackrSqunIcmK8chaMaURAU27qy6ryc3UBFGFZiBAbdiNa4Meta || {},
    alias: ["/surveys/garment-feedback"],
    component: () => import("/usr/src/app/apps/site-sk/app/pages/garment-feedback.vue")
  },
  {
    name: "onboarding-teams",
    path: "/onboarding/teams",
    meta: teamsc8XTOA_e_LbuqlLYWVQtA33a88_nakyK4QPrKJ8sZpwMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/onboarding/teams.vue")
  },
  {
    name: "support-warranty",
    path: "/support/warranty",
    meta: warrantyNIwsNpBIcBbXdqb0ukQvHH7tLZe_gOOVKl5lK1h9C1YMeta || {},
    alias: ["/support/warranty/submit-claim"],
    component: () => import("/usr/src/app/apps/site-sk/app/pages/support/warranty.vue")
  },
  {
    name: "order-confirmation",
    path: "/order/confirmation/:order",
    meta: confirmation4cpyrvksOy0N7gPDVagq2vzMOcJFpFPqjOrjeqMPxzQMeta || {},
    alias: ["/order/confirmation/:order"],
    component: () => import("/usr/src/app/apps/site-sk/app/pages/order/confirmation.vue")
  },
  {
    name: "onboarding-retailers",
    path: "/onboarding/retailers",
    meta: retailers0ro5QrV14Yn_MrL0GvN6OzjdWkZA7Q2ams_AkwrIcMcMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/onboarding/retailers.vue")
  },
  {
    name: "accept-invitation-uid",
    path: "/accept-invitation/:uid()",
    meta: _91uid_93HVyqa9fr2MAXBIoV9jE3UHVJqaGTfWhRiBpobk_Cro8Meta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/accept-invitation/[uid].vue")
  },
  {
    name: "onboarding-organizations",
    path: "/onboarding/organizations",
    meta: organizationsEfmSpOUEFEkEKj2NLxZ_sgTyYTvnEds5RIFm8WCZM1QMeta || {},
    component: () => import("/usr/src/app/apps/site-sk/app/pages/onboarding/organizations.vue")
  },
  {
    name: component_45stubtRLCMQ8C9tb_1wVAXA6zyyB2mYAIZfgpGxFzL5jBrdQMeta?.name,
    path: "/about-us",
    component: component_45stubtRLCMQ8C9tb_1wVAXA6zyyB2mYAIZfgpGxFzL5jBrdQ
  },
  {
    name: component_45stubtRLCMQ8C9tb_1wVAXA6zyyB2mYAIZfgpGxFzL5jBrdQMeta?.name,
    path: "/account/manage-team",
    component: component_45stubtRLCMQ8C9tb_1wVAXA6zyyB2mYAIZfgpGxFzL5jBrdQ
  },
  {
    name: component_45stubtRLCMQ8C9tb_1wVAXA6zyyB2mYAIZfgpGxFzL5jBrdQMeta?.name,
    path: "/warranty",
    component: component_45stubtRLCMQ8C9tb_1wVAXA6zyyB2mYAIZfgpGxFzL5jBrdQ
  },
  {
    name: component_45stubtRLCMQ8C9tb_1wVAXA6zyyB2mYAIZfgpGxFzL5jBrdQMeta?.name,
    path: "/redeem",
    component: component_45stubtRLCMQ8C9tb_1wVAXA6zyyB2mYAIZfgpGxFzL5jBrdQ
  },
  {
    name: component_45stubtRLCMQ8C9tb_1wVAXA6zyyB2mYAIZfgpGxFzL5jBrdQMeta?.name,
    path: "/ustring/:pathMatch(.*)",
    component: component_45stubtRLCMQ8C9tb_1wVAXA6zyyB2mYAIZfgpGxFzL5jBrdQ
  },
  {
    name: component_45stubtRLCMQ8C9tb_1wVAXA6zyyB2mYAIZfgpGxFzL5jBrdQMeta?.name,
    path: "/register",
    component: component_45stubtRLCMQ8C9tb_1wVAXA6zyyB2mYAIZfgpGxFzL5jBrdQ
  },
  {
    name: component_45stubtRLCMQ8C9tb_1wVAXA6zyyB2mYAIZfgpGxFzL5jBrdQMeta?.name,
    path: "/support/register",
    component: component_45stubtRLCMQ8C9tb_1wVAXA6zyyB2mYAIZfgpGxFzL5jBrdQ
  },
  {
    name: component_45stubtRLCMQ8C9tb_1wVAXA6zyyB2mYAIZfgpGxFzL5jBrdQMeta?.name,
    path: "/apparel",
    component: component_45stubtRLCMQ8C9tb_1wVAXA6zyyB2mYAIZfgpGxFzL5jBrdQ
  },
  {
    name: component_45stubtRLCMQ8C9tb_1wVAXA6zyyB2mYAIZfgpGxFzL5jBrdQMeta?.name,
    path: "/apparel/shirts",
    component: component_45stubtRLCMQ8C9tb_1wVAXA6zyyB2mYAIZfgpGxFzL5jBrdQ
  },
  {
    name: component_45stubtRLCMQ8C9tb_1wVAXA6zyyB2mYAIZfgpGxFzL5jBrdQMeta?.name,
    path: "/apparel/outerwear",
    component: component_45stubtRLCMQ8C9tb_1wVAXA6zyyB2mYAIZfgpGxFzL5jBrdQ
  },
  {
    name: component_45stubtRLCMQ8C9tb_1wVAXA6zyyB2mYAIZfgpGxFzL5jBrdQMeta?.name,
    path: "/apparel/socks",
    component: component_45stubtRLCMQ8C9tb_1wVAXA6zyyB2mYAIZfgpGxFzL5jBrdQ
  },
  {
    name: component_45stubtRLCMQ8C9tb_1wVAXA6zyyB2mYAIZfgpGxFzL5jBrdQMeta?.name,
    path: "/va-products/level-4-sterile-surgical-gowns/:pathMatch(.*)",
    component: component_45stubtRLCMQ8C9tb_1wVAXA6zyyB2mYAIZfgpGxFzL5jBrdQ
  },
  {
    name: component_45stubtRLCMQ8C9tb_1wVAXA6zyyB2mYAIZfgpGxFzL5jBrdQMeta?.name,
    path: "/va-products/level-3-sterile-surgical-gowns/:pathMatch(.*)",
    component: component_45stubtRLCMQ8C9tb_1wVAXA6zyyB2mYAIZfgpGxFzL5jBrdQ
  },
  {
    name: component_45stubtRLCMQ8C9tb_1wVAXA6zyyB2mYAIZfgpGxFzL5jBrdQMeta?.name,
    path: "/va-products/level-2-isolation-gowns/:pathMatch(.*)",
    component: component_45stubtRLCMQ8C9tb_1wVAXA6zyyB2mYAIZfgpGxFzL5jBrdQ
  },
  {
    name: component_45stubtRLCMQ8C9tb_1wVAXA6zyyB2mYAIZfgpGxFzL5jBrdQMeta?.name,
    path: "/va-products/level-3-surgical-mask/:pathMatch(.*)",
    component: component_45stubtRLCMQ8C9tb_1wVAXA6zyyB2mYAIZfgpGxFzL5jBrdQ
  },
  {
    name: component_45stubtRLCMQ8C9tb_1wVAXA6zyyB2mYAIZfgpGxFzL5jBrdQMeta?.name,
    path: "/va-products/over-the-head-protective-gowns/:pathMatch(.*)",
    component: component_45stubtRLCMQ8C9tb_1wVAXA6zyyB2mYAIZfgpGxFzL5jBrdQ
  },
  {
    name: component_45stubtRLCMQ8C9tb_1wVAXA6zyyB2mYAIZfgpGxFzL5jBrdQMeta?.name,
    path: "/symbols",
    component: component_45stubtRLCMQ8C9tb_1wVAXA6zyyB2mYAIZfgpGxFzL5jBrdQ
  }
]